
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4cf7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4cf7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jXlrK", function(module, exports) {
module.exports = import("0E2O5").then(()=>parcelRequire('cCo8R'));

});


var $5qD1E = parcelRequire("5qD1E");

var $2UrZ2 = parcelRequire("2UrZ2");

var $e8aKe = parcelRequire("e8aKe");

var $ftuQo = parcelRequire("ftuQo");

var $2pLFv = parcelRequire("2pLFv");
// NOTE: globalAnalysis is intentionally NOT statically imported here.
// eventHandlers <-> globalAnalysis would form a circular dependency (the
// dashboard navigates back into graph loading), which under Parcel's CommonJS
// interop leaves the exports object partially initialized and yields
// "renderGlobalAnalysis is not a function". We load it lazily instead.
let $c33e153c3b84c13d$var$_globalAnalysisMod = null;

async function $c33e153c3b84c13d$var$getGlobalAnalysis() {
    if (!$c33e153c3b84c13d$var$_globalAnalysisMod) $c33e153c3b84c13d$var$_globalAnalysisMod = await (parcelRequire("jXlrK"));
    return $c33e153c3b84c13d$var$_globalAnalysisMod;
}
/**
 * Refresh the Global Analysis dashboard after a new file is uploaded.
 * Always invalidates the cached aggregation so the next render uses fresh data.
 * If the Global Analysis tab is currently visible, re-renders it immediately;
 * otherwise the (cleared) dashboard re-renders lazily when the tab is shown.
 */ async function $c33e153c3b84c13d$var$refreshGlobalAnalysisAfterUpload() {
    try {
        const m = await $c33e153c3b84c13d$var$getGlobalAnalysis();
        m.invalidateGlobalAnalysisCache?.();
        // Reset the gene panels — gene annotation must be re-triggered for the
        // new file (it's an explicit, potentially slow action).
        m.resetGeneAnalysis?.();
        const pane = document.getElementById("globalAnalysisPane");
        const isVisible = pane && pane.classList.contains("active");
        if (isVisible) await m.renderGlobalAnalysis();
    } catch (err) {
        console.error("Failed to refresh global analysis after upload:", err);
    }
}
// Get references to the cy, info, and walks elements
const $c33e153c3b84c13d$var$cyContainer = document.getElementById("cy");
const $c33e153c3b84c13d$var$infoPanel = document.getElementById("info");
const $c33e153c3b84c13d$var$walksPanel = document.getElementById("walks");
// Get references to the maximize button and set initial state
const $c33e153c3b84c13d$var$maximizeButton = document.getElementById("toggleMaximize");
let $c33e153c3b84c13d$var$isMaximized = false;
// Add click event listener to the maximize button only if it exists
if ($c33e153c3b84c13d$var$maximizeButton) $c33e153c3b84c13d$var$maximizeButton.addEventListener("click", ()=>{
    if ($c33e153c3b84c13d$var$isMaximized) {
        // Restore previous layout
        $c33e153c3b84c13d$var$cyContainer.style.width = "";
        $c33e153c3b84c13d$var$cyContainer.style.height = "";
        $c33e153c3b84c13d$var$infoPanel.style.display = "";
        $c33e153c3b84c13d$var$walksPanel.style.display = "";
        $c33e153c3b84c13d$var$isMaximized = false;
    } else {
        // Maximize cy panel
        $c33e153c3b84c13d$var$cyContainer.style.width = "100%";
        $c33e153c3b84c13d$var$cyContainer.style.height = "100vh";
        $c33e153c3b84c13d$var$infoPanel.style.display = "none";
        $c33e153c3b84c13d$var$walksPanel.style.display = "none";
        $c33e153c3b84c13d$var$isMaximized = true;
    }
});
else console.warn("Element with ID 'toggleMaximize' not found in the DOM");
function $c33e153c3b84c13d$var$toggleLabels() {
    // Update labelsVisible state
    const nodelabelStyle = !(0, $e8aKe.getLabelsVisible)() ? function(ele) {
        return ele.data("gene_name") ? ele.data("gene_name") : "";
    } : "";
    const edgeLabelStyle = !(0, $e8aKe.getLabelsVisible)() ? function(ele) {
        return ele.data("weight") ? ele.data("weight") : "";
    } : "";
    (0, $5qD1E.STATE).cy.style().selector("node") // Select nodes
    .style({
        label: nodelabelStyle
    }).selector("edge") // Select edges
    .style({
        label: edgeLabelStyle
    }).update(); // Important to update the style
    (0, $e8aKe.setLabelsVisible)(!(0, $e8aKe.getLabelsVisible)());
}
// Add a null check before attaching the event listener
const $c33e153c3b84c13d$var$hiddenLabelBtn = document.getElementById("hiddenLabel");
if ($c33e153c3b84c13d$var$hiddenLabelBtn) $c33e153c3b84c13d$var$hiddenLabelBtn.addEventListener("click", $c33e153c3b84c13d$var$toggleLabels);
else console.warn("Element with ID 'hiddenLabel' not found in the DOM");
const $c33e153c3b84c13d$var$captureGraphBtn = document.getElementById("captureGraph");
if ($c33e153c3b84c13d$var$captureGraphBtn) $c33e153c3b84c13d$var$captureGraphBtn.addEventListener("click", ()=>{
    $c33e153c3b84c13d$var$showExportDialog();
});
else console.warn("Element with ID 'captureGraph' not found in the DOM");
/**
 * Show a modern export dialog with format options
 */ function $c33e153c3b84c13d$var$showExportDialog() {
    if (!(0, $5qD1E.STATE).cy) {
        window.showAlert?.("No graph loaded to export", "error");
        return;
    }
    // Create modal if it doesn't exist
    let modal = document.getElementById("exportModal");
    if (!modal) {
        modal = $c33e153c3b84c13d$var$createExportModal();
        document.body.appendChild(modal);
    }
    // Show the modal
    const bsModal = new bootstrap.Modal(modal);
    bsModal.show();
    // Set up export handlers
    $c33e153c3b84c13d$var$setupExportHandlers(modal, bsModal);
}
/**
 * Create the export modal HTML
 */ function $c33e153c3b84c13d$var$createExportModal() {
    const modal = document.createElement("div");
    modal.id = "exportModal";
    modal.className = "modal fade";
    modal.setAttribute("tabindex", "-1");
    modal.innerHTML = `
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="bi bi-download me-2"></i>Export Graph
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label fw-bold">Select Export Format:</label>
            <div class="export-format-grid">
              <div class="export-format-option" data-format="png">
                <i class="bi bi-file-earmark-image"></i>
                <div class="format-name">PNG</div>
                <div class="format-desc">Raster image, best for presentations</div>
              </div>
              <div class="export-format-option" data-format="jpg">
                <i class="bi bi-file-earmark-image-fill"></i>
                <div class="format-name">JPG</div>
                <div class="format-desc">Compressed image, smaller file size</div>
              </div>
              <div class="export-format-option active" data-format="svg">
                <i class="bi bi-file-earmark-code"></i>
                <div class="format-name">SVG</div>
                <div class="format-desc">Vector image, scalable and editable</div>
              </div>
              <div class="export-format-option" data-format="json">
                <i class="bi bi-filetype-json"></i>
                <div class="format-name">JSON</div>
                <div class="format-desc">Graph data for reloading</div>
              </div>
            </div>
          </div>

          <div class="mb-3" id="exportOptions">
            <label class="form-label fw-bold">Options:</label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="exportFullGraph" checked>
              <label class="form-check-label" for="exportFullGraph">
                Export full graph (include all elements)
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="exportTransparentBg">
              <label class="form-check-label" for="exportTransparentBg">
                Transparent background
              </label>
            </div>
          </div>

          <div class="mb-3" id="scaleOptions">
            <label for="exportScale" class="form-label fw-bold">Scale:</label>
            <input type="range" class="form-range" id="exportScale" min="1" max="4" step="0.5" value="2">
            <div class="d-flex justify-content-between">
              <small>1x</small>
              <small id="scaleValue">2x</small>
              <small>4x</small>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" id="confirmExport">
            <i class="bi bi-download me-2"></i>Export
          </button>
        </div>
      </div>
    </div>
  `;
    // Add styles
    if (!document.getElementById("exportModalStyles")) {
        const style = document.createElement("style");
        style.id = "exportModalStyles";
        style.textContent = `
      .export-format-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
        margin-top: 12px;
      }

      .export-format-option {
        border: 2px solid #dee2e6;
        border-radius: 8px;
        padding: 16px;
        text-align: center;
        cursor: pointer;
        transition: all 0.2s;
        background: var(--bg-primary, #fff);
      }

      .export-format-option:hover {
        border-color: var(--aurora-primary, #6366f1);
        background: var(--bg-secondary, #f8f9fa);
      }

      .export-format-option.active {
        border-color: var(--aurora-primary, #6366f1);
        background: rgba(0, 123, 255, 0.1);
      }

      .export-format-option i {
        font-size: 2rem;
        color: var(--aurora-primary, #6366f1);
        margin-bottom: 8px;
      }

      .format-name {
        font-weight: bold;
        margin-bottom: 4px;
        color: var(--text-primary, #212529);
      }

      .format-desc {
        font-size: 0.75rem;
        color: var(--text-secondary, #475569);
      }

      [data-theme="dark"] .export-format-option {
        background: var(--bg-primary, #1a1a1a);
        border-color: #495057;
      }

      [data-theme="dark"] .export-format-option:hover {
        background: var(--bg-secondary, #2d2d2d);
      }
    `;
        document.head.appendChild(style);
    }
    return modal;
}
/**
 * Set up export event handlers
 */ function $c33e153c3b84c13d$var$setupExportHandlers(modal, bsModal) {
    // Format selection
    const formatOptions = modal.querySelectorAll(".export-format-option");
    formatOptions.forEach((option)=>{
        option.addEventListener("click", ()=>{
            formatOptions.forEach((o)=>o.classList.remove("active"));
            option.classList.add("active");
            $c33e153c3b84c13d$var$updateExportOptions(option.dataset.format, modal);
        });
    });
    // Scale slider
    const scaleSlider = modal.querySelector("#exportScale");
    const scaleValue = modal.querySelector("#scaleValue");
    if (scaleSlider && scaleValue) scaleSlider.addEventListener("input", (e)=>{
        scaleValue.textContent = `${e.target.value}x`;
    });
    // Export button
    const exportBtn = modal.querySelector("#confirmExport");
    if (exportBtn) {
        exportBtn.replaceWith(exportBtn.cloneNode(true));
        const newExportBtn = modal.querySelector("#confirmExport");
        newExportBtn.addEventListener("click", async ()=>{
            const activeFormat = modal.querySelector(".export-format-option.active");
            const format = activeFormat?.dataset.format || "svg";
            const scale = parseFloat(scaleSlider?.value || 2);
            const fullGraph = modal.querySelector("#exportFullGraph")?.checked ?? true;
            const transparentBg = modal.querySelector("#exportTransparentBg")?.checked ?? false;
            try {
                await $c33e153c3b84c13d$var$exportGraph(format, {
                    scale: scale,
                    fullGraph: fullGraph,
                    transparentBg: transparentBg
                });
                bsModal.hide();
                window.showAlert?.(`Graph exported as ${format.toUpperCase()}!`, "success", 2000);
            } catch (error) {
                console.error("Export failed:", error);
                window.showAlert?.(`Export failed: ${error.message}`, "error");
            }
        });
    }
}
/**
 * Update export options based on selected format
 */ function $c33e153c3b84c13d$var$updateExportOptions(format, modal) {
    const scaleOptions = modal.querySelector("#scaleOptions");
    const exportOptions = modal.querySelector("#exportOptions");
    if (format === "json") {
        scaleOptions.style.display = "none";
        exportOptions.style.display = "none";
    } else {
        scaleOptions.style.display = format === "svg" ? "none" : "block";
        exportOptions.style.display = "block";
    }
}
/**
 * Export graph in the specified format
 */ async function $c33e153c3b84c13d$var$exportGraph(format, options = {}) {
    if (!(0, $5qD1E.STATE).cy) throw new Error("No graph loaded");
    const { scale: scale = 2, fullGraph: fullGraph = true, transparentBg: transparentBg = false } = options;
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-");
    let data, filename, mimeType;
    switch(format){
        case "png":
            data = (0, $5qD1E.STATE).cy.png({
                full: fullGraph,
                scale: scale,
                bg: transparentBg ? "transparent" : "#ffffff"
            });
            filename = `graph_${timestamp}.png`;
            break;
        case "jpg":
            data = (0, $5qD1E.STATE).cy.jpg({
                full: fullGraph,
                scale: scale,
                bg: "#ffffff",
                quality: 0.9
            });
            filename = `graph_${timestamp}.jpg`;
            break;
        case "svg":
            // Cytoscape SVG export
            const svgContent = (0, $5qD1E.STATE).cy.svg({
                full: fullGraph,
                bg: transparentBg ? "transparent" : "#ffffff"
            });
            const blob = new Blob([
                svgContent
            ], {
                type: "image/svg+xml"
            });
            data = URL.createObjectURL(blob);
            filename = `graph_${timestamp}.svg`;
            mimeType = "image/svg+xml";
            break;
        case "json":
            const jsonData = (0, $5qD1E.STATE).cy.json();
            const jsonBlob = new Blob([
                JSON.stringify(jsonData, null, 2)
            ], {
                type: "application/json"
            });
            data = URL.createObjectURL(jsonBlob);
            filename = `graph_${timestamp}.json`;
            mimeType = "application/json";
            break;
        default:
            throw new Error(`Unsupported format: ${format}`);
    }
    // Download the file
    const downloadLink = document.createElement("a");
    downloadLink.href = data;
    downloadLink.download = filename;
    downloadLink.click();
    // Clean up blob URLs
    if (format === "svg" || format === "json") setTimeout(()=>URL.revokeObjectURL(data), 100);
}
// IGV button removed - feature not needed
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $2UrZ2.resizePanels)();
});
const $c33e153c3b84c13d$var$uploadInput = document.getElementById("uploadInput");
const $c33e153c3b84c13d$var$uploadBtn = document.getElementById("uploadBtn");
if ($c33e153c3b84c13d$var$uploadInput) $c33e153c3b84c13d$var$uploadInput.addEventListener("change", $c33e153c3b84c13d$var$handleFileUpload);
else console.warn("Element with ID 'uploadInput' not found in the DOM");
if ($c33e153c3b84c13d$var$uploadBtn && $c33e153c3b84c13d$var$uploadInput) $c33e153c3b84c13d$var$uploadBtn.addEventListener("click", ()=>$c33e153c3b84c13d$var$uploadInput.click());
else console.warn("Upload button or input not found in the DOM");
/**
 * Parses graph IDs from raw TSG content.
 * The TSG format delimits graphs with a "G <graphId>" line. The WASM parser
 * drops these IDs, so we recover them here to label the graph selector.
 * Returns an array of graph IDs in file order. Falls back to an empty array
 * when no G-lines are present (e.g. single-graph TSG without an explicit ID).
 * @param {string} content - Raw TSG file text
 * @returns {string[]}
 */ function $c33e153c3b84c13d$var$parseGraphIds(content) {
    const ids = [];
    if (typeof content !== "string") return ids;
    const lines = content.split(/\r?\n/);
    for (const line of lines)// G-line: "G\t<graphId>" (tab or whitespace separated)
    if (/^G\s/.test(line)) {
        const parts = line.split(/\s+/);
        if (parts.length >= 2 && parts[1]) ids.push(parts[1].trim());
    }
    return ids;
}
/**
 * Parse the maximum path length (in nodes) per graph from raw TSG/GTA "P" lines.
 *
 * Path lines have the form:
 *   P  <pathId>  <elem1>  <elem2>  ...
 * where each element is a node ("TSN...") or edge ("TSE...") id with an
 * optional orientation suffix ("+"/"-"). "P" lines belong to the most recent
 * "G <graphId>" block, so we accumulate the per-graph maximum node-count as we
 * scan the file in order. The returned array is parallel to the WASM's parsed
 * graph order (same file order).
 *
 * A graph with no "P" lines gets a null entry so Global Analysis can fall back
 * to a computed longest path.
 *
 * @param {string} content - Raw TSG/GTA file text
 * @returns {(number|null)[]} max path node-count per graph, in file order
 */ /**
 * Parse per-graph path statistics from raw TSG/GTA "P" lines.
 *
 * Path lines have the form:
 *   P  <pathId>  <elem1>  <elem2>  ...
 * where each element is a node ("TSN...") or edge ("TSE...") id with an
 * optional orientation suffix ("+"/"-"). "P" lines belong to the most recent
 * "G <graphId>" block. For each graph we collect:
 *   - maxPathLen: the largest node-count across its paths (or null if none)
 *   - pathLengths: the node-count of every path (empty array if none)
 *   - pathCount: number of "P" lines for the graph
 *
 * Arrays are parallel to the WASM's parsed graph order (same file order).
 * Graphs with no "P" lines get maxPathLen=null so Global Analysis can fall back
 * to a computed enumeration.
 *
 * @param {string} content - Raw TSG/GTA file text
 * @returns {{maxPathLen:(number|null)[], pathLengths:number[][], pathCount:number[]}}
 */ function $c33e153c3b84c13d$var$parsePathStats(content) {
    const maxPathLen = [];
    const pathLengths = [];
    const pathCount = [];
    if (typeof content !== "string") return {
        maxPathLen: maxPathLen,
        pathLengths: pathLengths,
        pathCount: pathCount
    };
    const lines = content.split(/\r?\n/);
    let gi = -1; // current graph index (incremented on each G-line)
    for (const line of lines){
        if (/^G\s/.test(line)) {
            gi += 1;
            maxPathLen[gi] = null;
            pathLengths[gi] = [];
            pathCount[gi] = 0;
            continue;
        }
        if (gi >= 0 && /^P\s/.test(line)) {
            const parts = line.split(/\s+/);
            // parts[0] = "P", parts[1] = path id, parts[2..] = elements
            let nodeCount = 0;
            for(let k = 2; k < parts.length; k++)// Node elements are prefixed "TSN"; ignore orientation suffix.
            if (parts[k] && parts[k].startsWith("TSN")) nodeCount += 1;
            pathLengths[gi].push(nodeCount);
            pathCount[gi] += 1;
            if (nodeCount > (maxPathLen[gi] || 0)) maxPathLen[gi] = nodeCount;
        }
    }
    return {
        maxPathLen: maxPathLen,
        pathLengths: pathLengths,
        pathCount: pathCount
    };
}
function $c33e153c3b84c13d$var$handleFileUpload(event) {
    const file = event.target.files[0];
    if (!file) return;
    // Show loading indicator
    const loadingId = `upload-${Date.now()}`;
    window.loadingIndicator?.show(loadingId, {
        message: `Loading ${file.name}...`,
        type: "spinner",
        overlay: true
    });
    const reader = new FileReader();
    reader.onload = async (e)=>{
        const content = e.target.result;
        const fileExtension = file.name.split(".").pop().toLowerCase();
        try {
            if (fileExtension === "json") {
                window.loadingIndicator?.updateMessage(loadingId, "Parsing JSON data...");
                // Handle JSON file
                const jsonData = JSON.parse(content);
                window.loadingIndicator?.updateMessage(loadingId, "Rendering graph...");
                (0, $5qD1E.loadGraphDataFromServer)(jsonData);
                // Single JSON file: one graph at index 0, no IDs.
                // Populate graph_jsons so Global Analysis can read this graph
                // (content is already the JSON string in the format expected).
                (0, $5qD1E.STATE).graph_jsons = [
                    content
                ];
                (0, $5qD1E.STATE).graph_ids = [];
                (0, $5qD1E.STATE).graph_max_path_len = []; // computed lazily from possible_paths / DFS
                (0, $5qD1E.STATE).graph_path_lengths = []; // computed lazily via enumeration
                (0, $5qD1E.STATE).graph_path_count = [];
                (0, $5qD1E.STATE).currentGraphIndex = 0;
                // Hide graph selector for single JSON files
                document.getElementById("graphSelectorContainer").classList.add("d-none");
                window.showAlert?.("Graph loaded successfully!", "success", 2000);
            } else if (fileExtension === "tsg" || fileExtension === "gta") {
                // TSG and GTA share the same text format and are parsed by the
                // same WASM entry point.
                const fmt = fileExtension.toUpperCase();
                window.loadingIndicator?.updateMessage(loadingId, `Parsing ${fmt} file...`);
                // wait for the result from promise
                (0, $5qD1E.STATE).graph_jsons = await window.parse_tsgFile(content);
                // Recover graph IDs from the raw "G" lines (WASM drops them).
                // Only keep them if the count matches the parsed graph count, so
                // the selector labels stay aligned with the actual graphs.
                const parsedIds = $c33e153c3b84c13d$var$parseGraphIds(content);
                (0, $5qD1E.STATE).graph_ids = parsedIds.length === (0, $5qD1E.STATE).graph_jsons.length ? parsedIds : [];
                // Recover per-graph path statistics from raw "P" lines (also
                // dropped by the WASM): max path length, every path length, and
                // the path count. Keep only when aligned with the parsed graph
                // count; otherwise leave empty so Global Analysis computes them
                // via enumeration.
                const pathStats = $c33e153c3b84c13d$var$parsePathStats(content);
                const aligned = pathStats.maxPathLen.length === (0, $5qD1E.STATE).graph_jsons.length;
                (0, $5qD1E.STATE).graph_max_path_len = aligned ? pathStats.maxPathLen : [];
                (0, $5qD1E.STATE).graph_path_lengths = aligned ? pathStats.pathLengths : [];
                (0, $5qD1E.STATE).graph_path_count = aligned ? pathStats.pathCount : [];
                // Show graph selector if multiple graphs are available
                const graphCount = (0, $5qD1E.STATE).graph_jsons.length;
                window.loadingIndicator?.updateMessage(loadingId, `Found ${graphCount} graph${graphCount > 1 ? "s" : ""}...`);
                if (graphCount > 1) $c33e153c3b84c13d$var$setupGraphSelector(graphCount);
                else document.getElementById("graphSelectorContainer").classList.add("d-none");
                // Load the first graph by default
                window.loadingIndicator?.updateMessage(loadingId, "Rendering graph...");
                const jsonData = JSON.parse((0, $5qD1E.STATE).graph_jsons[0]);
                (0, $5qD1E.loadGraphDataFromServer)(jsonData);
                (0, $5qD1E.STATE).currentGraphIndex = 0;
                window.showAlert?.(`Loaded ${graphCount} graph${graphCount > 1 ? "s" : ""} successfully!`, "success", 2000);
            } else throw new Error(`Unsupported file type ".${fileExtension}". Please upload a .json, .tsg, or .gta file.`);
            // New file loaded → refresh Global Analysis (invalidate cache and
            // re-render if its tab is currently visible). Done after
            // STATE.graph_jsons is set so the new data is picked up.
            $c33e153c3b84c13d$var$refreshGlobalAnalysisAfterUpload();
        } catch (error) {
            console.error("Error processing file:", error);
            window.showAlert?.("Error processing file: " + error.message, "error");
        } finally{
            // Always hide the loading indicator, regardless of which branch ran
            // (or whether an error/unsupported-extension short-circuited it).
            window.loadingIndicator?.hide(loadingId);
        }
    };
    reader.onerror = ()=>{
        window.loadingIndicator?.hide(loadingId);
        window.showAlert?.("Failed to read file", "error");
    };
    reader.readAsText(file);
    // Reset the file input so the same file can be re-uploaded
    event.target.value = "";
}
function $c33e153c3b84c13d$export$3edc6d15f574dc2c(index) {
    const id = (0, $5qD1E.STATE).graph_ids && (0, $5qD1E.STATE).graph_ids[index];
    return id ? id : `Graph ${index + 1}`;
}
function $c33e153c3b84c13d$export$21d6718bb19ff5e3(index, notify = true) {
    if (!(0, $5qD1E.STATE).graph_jsons || index < 0 || index >= (0, $5qD1E.STATE).graph_jsons.length) {
        console.warn(`loadGraphByIndex: invalid index ${index}`);
        return false;
    }
    if (index === (0, $5qD1E.STATE).currentGraphIndex && (0, $5qD1E.STATE).cy) // Already loaded — no-op (avoids a costly re-init).
    return true;
    try {
        const jsonData = JSON.parse((0, $5qD1E.STATE).graph_jsons[index]);
        (0, $5qD1E.loadGraphDataFromServer)(jsonData);
        (0, $5qD1E.STATE).currentGraphIndex = index;
        // Keep the toolbar dropdown in sync when navigation is programmatic.
        const graphSelect = document.getElementById("graphSelect");
        if (graphSelect && String(graphSelect.value) !== String(index)) graphSelect.value = String(index);
        if (notify) window.showAlert?.(`Loaded ${$c33e153c3b84c13d$export$3edc6d15f574dc2c(index)}`, "success", 2000);
        // Refresh the dashboard's active-row highlight if it's rendered.
        return true;
    } catch (error) {
        console.error("Error loading selected graph:", error);
        window.showAlert?.(`Error loading ${$c33e153c3b84c13d$export$3edc6d15f574dc2c(index)}: ${error.message}`, "error");
        return false;
    }
}
// Expose for cross-module use without creating static import cycles
// (breakpointCirclePlot.js calls this for cross-graph navigation).
window.loadGraphByIndex = $c33e153c3b84c13d$export$21d6718bb19ff5e3;
/**
 * Sets up the graph selector dropdown with options based on the number of available graphs
 * @param {number} graphCount - The number of available graphs
 */ function $c33e153c3b84c13d$var$setupGraphSelector(graphCount) {
    const graphSelect = document.getElementById("graphSelect");
    const graphSelectorContainer = document.getElementById("graphSelectorContainer");
    // Clear existing options
    graphSelect.innerHTML = "";
    // Add options for each graph, labelled by graph ID when available
    for(let i = 0; i < graphCount; i++){
        const option = document.createElement("option");
        option.value = i;
        option.textContent = $c33e153c3b84c13d$export$3edc6d15f574dc2c(i);
        // Always expose the index-based name as a tooltip for disambiguation
        option.title = `Graph ${i + 1}${(0, $5qD1E.STATE).graph_ids[i] ? ` (${(0, $5qD1E.STATE).graph_ids[i]})` : ""}`;
        graphSelect.appendChild(option);
    }
    // Show the selector
    graphSelectorContainer.classList.remove("d-none");
    // Replace element to remove any previous change listeners, then add fresh one
    const freshSelect = graphSelect.cloneNode(true);
    graphSelect.parentNode.replaceChild(freshSelect, graphSelect);
    freshSelect.addEventListener("change", function() {
        const selectedIndex = parseInt(this.value);
        if (Number.isNaN(selectedIndex)) return; // "No matching graph" placeholder
        $c33e153c3b84c13d$export$21d6718bb19ff5e3(selectedIndex);
    });
    // (Re)initialize the fuzzy graph-ID search for this set of graphs.
    $c33e153c3b84c13d$var$setupGraphSearch(graphCount);
}
/**
 * Fuzzy subsequence matcher. Returns a score (higher = better) if every
 * character of `query` appears in `text` in order, otherwise -1.
 * Rewards contiguous runs, start-of-string, and shorter targets.
 * @param {string} query
 * @param {string} text
 * @returns {number}
 */ function $c33e153c3b84c13d$var$fuzzyScore(query, text) {
    const q = query.toLowerCase();
    const t = text.toLowerCase();
    if (!q) return 0;
    // Fast path: exact substring gets a high base score.
    const subIdx = t.indexOf(q);
    if (subIdx !== -1) return 1000 - subIdx * 2 - (t.length - q.length);
    let ti = 0;
    let score = 0;
    let run = 0;
    let prevMatch = -2;
    for(let qi = 0; qi < q.length; qi++){
        const ch = q[qi];
        let found = -1;
        for(let j = ti; j < t.length; j++)if (t[j] === ch) {
            found = j;
            break;
        }
        if (found === -1) return -1; // not a subsequence
        if (found === prevMatch + 1) {
            run += 1;
            score += 5 + run * 2; // contiguous bonus
        } else {
            run = 0;
            score += 1;
        }
        if (found === 0) score += 4; // start-of-string bonus
        prevMatch = found;
        ti = found + 1;
    }
    // Prefer shorter targets (closer match density).
    score -= Math.max(0, t.length - q.length) * 0.2;
    return score;
}
/**
 * Sets up the fuzzy graph-ID search box next to the graph selector.
 * Typing filters graphs by ID; clicking a result (or pressing Enter on the top
 * match) loads that graph.
 * @param {number} graphCount
 */ function $c33e153c3b84c13d$var$setupGraphSearch(graphCount) {
    const input = document.getElementById("graphSearchInput");
    const results = document.getElementById("graphSearchResults");
    if (!input || !results) return;
    // Clone to drop any previous listeners (re-init per upload).
    const freshInput = input.cloneNode(true);
    input.parentNode.replaceChild(freshInput, input);
    freshInput.value = "";
    results.innerHTML = "";
    results.classList.add("d-none");
    // Build the searchable label list once.
    const items = [];
    for(let i = 0; i < graphCount; i++)items.push({
        index: i,
        label: $c33e153c3b84c13d$export$3edc6d15f574dc2c(i)
    });
    let currentMatches = [];
    /**
     * Rebuild the native <select> option list to only include graphs whose
     * label matches the search text (fuzzy). An empty query restores every
     * option. The current selection is preserved when it still matches;
     * otherwise the selected value is left unchanged (no graph is loaded here —
     * loading happens on explicit selection/Enter/result click).
     * @param {string} query
     */ function filterSelectOptions(query) {
        const sel = document.getElementById("graphSelect");
        if (!sel) return;
        const q = (query || "").trim();
        // Compute the set of matching indices (all when query is empty).
        let matched;
        if (!q) matched = items.map((it)=>it.index);
        else matched = items.map((it)=>({
                index: it.index,
                score: $c33e153c3b84c13d$var$fuzzyScore(q, it.label)
            })).filter((it)=>it.score >= 0).sort((a, b)=>b.score - a.score).map((it)=>it.index);
        const prevValue = sel.value;
        sel.innerHTML = "";
        if (!matched.length) {
            const opt = document.createElement("option");
            opt.value = "";
            opt.textContent = "No matching graph";
            opt.disabled = true;
            opt.selected = true;
            sel.appendChild(opt);
            return;
        }
        for (const idx of matched){
            const option = document.createElement("option");
            option.value = idx;
            option.textContent = $c33e153c3b84c13d$export$3edc6d15f574dc2c(idx);
            option.title = `Graph ${idx + 1}${(0, $5qD1E.STATE).graph_ids[idx] ? ` (${(0, $5qD1E.STATE).graph_ids[idx]})` : ""}`;
            sel.appendChild(option);
        }
        // Keep the previously selected graph selected if it still matches;
        // otherwise fall back to the currently loaded graph or the top match.
        if (matched.includes(Number(prevValue))) sel.value = prevValue;
        else if (matched.includes((0, $5qD1E.STATE).currentGraphIndex)) sel.value = String((0, $5qD1E.STATE).currentGraphIndex);
        else sel.value = String(matched[0]);
    }
    // Position the fixed dropdown directly under the search input so it isn't
    // clipped by the toolbar's overflow:auto.
    function positionResults() {
        const r = freshInput.getBoundingClientRect();
        results.style.top = `${r.bottom + 2}px`;
        results.style.left = `${r.left}px`;
        results.style.minWidth = `${Math.max(r.width, 240)}px`;
    }
    function computeMatches(query) {
        if (!query.trim()) // Empty query → show all graphs (capped).
        return items.slice(0, 20).map((it)=>({
                ...it,
                score: 0
            }));
        return items.map((it)=>({
                ...it,
                score: $c33e153c3b84c13d$var$fuzzyScore(query, it.label)
            })).filter((it)=>it.score >= 0).sort((a, b)=>b.score - a.score).slice(0, 12);
    }
    function renderResults(matches) {
        currentMatches = matches;
        positionResults();
        if (!matches.length) {
            results.innerHTML = '<div class="graph-search-empty">No matching graph</div>';
            results.classList.remove("d-none");
            return;
        }
        results.innerHTML = matches.map((m, i)=>`<button type="button" class="graph-search-item${i === 0 ? " active" : ""}"
                        data-index="${m.index}">
                        <span class="gs-label">${$c33e153c3b84c13d$var$escapeHtmlSafe(m.label)}</span>
                        <span class="gs-idx">#${m.index + 1}</span>
                    </button>`).join("");
        results.classList.remove("d-none");
        results.querySelectorAll(".graph-search-item").forEach((btn)=>{
            btn.addEventListener("mousedown", (e)=>{
                // mousedown (not click) so it fires before input blur hides list
                e.preventDefault();
                const idx = parseInt(btn.getAttribute("data-index"), 10);
                selectMatch(idx);
            });
        });
    }
    function selectMatch(idx) {
        $c33e153c3b84c13d$export$21d6718bb19ff5e3(idx);
        freshInput.value = "";
        results.classList.add("d-none");
        // Restore the full option list now that the search is cleared, then
        // reflect the loaded graph as the current selection.
        filterSelectOptions("");
        const sel = document.getElementById("graphSelect");
        if (sel) sel.value = String(idx);
    }
    freshInput.addEventListener("input", ()=>{
        // Filter both the fuzzy results dropdown AND the native <select> list.
        renderResults(computeMatches(freshInput.value));
        filterSelectOptions(freshInput.value);
    });
    freshInput.addEventListener("focus", ()=>{
        renderResults(computeMatches(freshInput.value));
    });
    freshInput.addEventListener("keydown", (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            if (currentMatches.length) selectMatch(currentMatches[0].index);
        } else if (e.key === "Escape") {
            results.classList.add("d-none");
            // Clear the search and restore the full dropdown list.
            freshInput.value = "";
            filterSelectOptions("");
            freshInput.blur();
        }
    });
    freshInput.addEventListener("blur", ()=>{
        // Delay so a result mousedown can register first.
        setTimeout(()=>results.classList.add("d-none"), 120);
    });
}
// Minimal HTML escaping for search result labels.
function $c33e153c3b84c13d$var$escapeHtmlSafe(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
// Breakpoint Circle Plot button — opens the circos-style modal.
// Statically imported (see top of file) so we don't depend on a dynamic
// chunk URL that can go stale after a Parcel dev-server restart.
const $c33e153c3b84c13d$var$circlePlotBtn = document.getElementById("circlePlotBtn");
if ($c33e153c3b84c13d$var$circlePlotBtn) $c33e153c3b84c13d$var$circlePlotBtn.addEventListener("click", ()=>{
    try {
        (0, $2pLFv.showBreakpointCirclePlotModal)();
    } catch (err) {
        console.error("Failed to open circle plot:", err);
        window.showAlert?.("Failed to open circle plot: " + (err?.message || err), "error");
    }
});
else console.warn("Element with ID 'circlePlotBtn' not found in the DOM");
// Hide the graph-view node/edge tooltip. The Cytoscape "mouseout" event does
// not fire when the canvas is hidden by a tab switch, so the tooltip can stay
// stuck on screen. Call this when leaving the Graph View.
function $c33e153c3b84c13d$var$hideGraphTooltip() {
    const tooltip = document.getElementById("tooltip");
    if (tooltip) {
        tooltip.classList.remove("tooltip-visible");
        tooltip.style.display = "none";
    }
}
// Global Analysis tab — lazily render the dashboard when the tab is shown.
// Deferred until visible so D3 can measure the chart containers correctly.
const $c33e153c3b84c13d$var$globalAnalysisTab = document.getElementById("globalAnalysisTab");
if ($c33e153c3b84c13d$var$globalAnalysisTab) {
    // Hide the Graph View tooltip as soon as we start switching tabs.
    $c33e153c3b84c13d$var$globalAnalysisTab.addEventListener("show.bs.tab", $c33e153c3b84c13d$var$hideGraphTooltip);
    $c33e153c3b84c13d$var$globalAnalysisTab.addEventListener("shown.bs.tab", async ()=>{
        try {
            const m = await $c33e153c3b84c13d$var$getGlobalAnalysis();
            await m.renderGlobalAnalysis();
        } catch (err) {
            console.error("Failed to render global analysis:", err);
            window.showAlert?.("Failed to render global analysis: " + (err?.message || err), "error");
        }
    });
}
// Manual refresh button inside the Global Analysis dashboard
const $c33e153c3b84c13d$var$gaRefreshBtn = document.getElementById("ga-refresh-btn");
if ($c33e153c3b84c13d$var$gaRefreshBtn) $c33e153c3b84c13d$var$gaRefreshBtn.addEventListener("click", async ()=>{
    try {
        const m = await $c33e153c3b84c13d$var$getGlobalAnalysis();
        m.invalidateGlobalAnalysisCache?.();
        await m.renderGlobalAnalysis({
            force: true
        });
    } catch (err) {
        console.error("Failed to refresh global analysis:", err);
        window.showAlert?.("Failed to refresh global analysis: " + (err?.message || err), "error");
    }
});
// Global Analysis: export the per-graph summary table as CSV.
const $c33e153c3b84c13d$var$gaExportCsvBtn = document.getElementById("ga-export-csv-btn");
if ($c33e153c3b84c13d$var$gaExportCsvBtn) $c33e153c3b84c13d$var$gaExportCsvBtn.addEventListener("click", async ()=>{
    try {
        const m = await $c33e153c3b84c13d$var$getGlobalAnalysis();
        m.exportSummaryCsv?.();
    } catch (err) {
        console.error("Failed to export CSV:", err);
        window.showAlert?.("Failed to export CSV: " + (err?.message || err), "error");
    }
});
// Global Analysis: per-card PNG export buttons (delegated). Each button carries
// data-export-chart (container id) and data-export-name (filename base).
const $c33e153c3b84c13d$var$gaPane = document.getElementById("globalAnalysisPane");
if ($c33e153c3b84c13d$var$gaPane) $c33e153c3b84c13d$var$gaPane.addEventListener("click", async (event)=>{
    const btn = event.target.closest(".ga-png-btn");
    if (!btn) return;
    event.preventDefault();
    const containerId = btn.getAttribute("data-export-chart");
    const name = btn.getAttribute("data-export-name") || "ga_figure";
    if (!containerId) return;
    try {
        const m = await $c33e153c3b84c13d$var$getGlobalAnalysis();
        m.exportChartPng?.(containerId, name);
    } catch (err) {
        console.error("Failed to export figure PNG:", err);
        window.showAlert?.("Failed to export figure: " + (err?.message || err), "error");
    }
});
// Global Analysis: parameters panel — filter WHICH graphs are included.
const $c33e153c3b84c13d$var$gaFilterApplyBtn = document.getElementById("ga-filter-apply-btn");
const $c33e153c3b84c13d$var$gaFilterClearBtn = document.getElementById("ga-filter-clear-btn");
/** Read the filter panel inputs into a plain object. */ function $c33e153c3b84c13d$var$readGaFilterInputs() {
    const num = (id)=>{
        const el = document.getElementById(id);
        const v = el ? parseFloat(el.value) : 0;
        return Number.isFinite(v) && v > 0 ? v : 0;
    };
    const str = (id)=>{
        const el = document.getElementById(id);
        return el ? el.value.trim() : "";
    };
    return {
        minNodes: num("ga-filter-min-nodes"),
        minEdges: num("ga-filter-min-edges"),
        minTotalWeight: num("ga-filter-min-weight"),
        minTotalJsr: num("ga-filter-min-jsr"),
        svType: str("ga-filter-svtype"),
        chrom: str("ga-filter-chrom")
    };
}
if ($c33e153c3b84c13d$var$gaFilterApplyBtn) $c33e153c3b84c13d$var$gaFilterApplyBtn.addEventListener("click", async ()=>{
    try {
        const m = await $c33e153c3b84c13d$var$getGlobalAnalysis();
        m.setGlobalFilters?.($c33e153c3b84c13d$var$readGaFilterInputs());
        // Aggregation cache is preserved; only the filtered view changes.
        await m.renderGlobalAnalysis();
    } catch (err) {
        console.error("Failed to apply global analysis filters:", err);
        window.showAlert?.("Failed to apply filters: " + (err?.message || err), "error");
    }
});
if ($c33e153c3b84c13d$var$gaFilterClearBtn) $c33e153c3b84c13d$var$gaFilterClearBtn.addEventListener("click", async ()=>{
    [
        "ga-filter-min-nodes",
        "ga-filter-min-edges",
        "ga-filter-min-weight",
        "ga-filter-min-jsr"
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.value = "0";
    });
    [
        "ga-filter-svtype",
        "ga-filter-chrom"
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.value = "";
    });
    try {
        const m = await $c33e153c3b84c13d$var$getGlobalAnalysis();
        m.setGlobalFilters?.({
            minNodes: 0,
            minEdges: 0,
            minTotalWeight: 0,
            minTotalJsr: 0,
            svType: "",
            chrom: ""
        });
        await m.renderGlobalAnalysis();
    } catch (err) {
        console.error("Failed to clear global analysis filters:", err);
    }
});
// Global Analysis: annotate genes across all graphs and render gene panels
const $c33e153c3b84c13d$var$gaAnnotateGenesBtn = document.getElementById("ga-annotate-genes-btn");
if ($c33e153c3b84c13d$var$gaAnnotateGenesBtn) $c33e153c3b84c13d$var$gaAnnotateGenesBtn.addEventListener("click", async ()=>{
    try {
        const m = await $c33e153c3b84c13d$var$getGlobalAnalysis();
        await m.renderGeneAnalysis();
    } catch (err) {
        console.error("Failed to annotate genes:", err);
        window.showAlert?.("Failed to annotate genes: " + (err?.message || err), "error");
    }
});
// Add the clear highlights button event handler
const $c33e153c3b84c13d$var$clearHighlightsBtn = document.getElementById("clearHighlights");
if ($c33e153c3b84c13d$var$clearHighlightsBtn) $c33e153c3b84c13d$var$clearHighlightsBtn.addEventListener("click", ()=>{
    (0, $5qD1E.clearNodeHighlights)((0, $5qD1E.STATE).cy);
});
else console.warn("Element with ID 'clearHighlights' not found in the DOM");
// Gene annotation direct action (if modal doesn't work for some reason)
const $c33e153c3b84c13d$var$geneAnnotationBtn = document.getElementById("geneAnnotationBtn");
if ($c33e153c3b84c13d$var$geneAnnotationBtn) $c33e153c3b84c13d$var$geneAnnotationBtn.addEventListener("click", async (e)=>{
    // Direct annotation without modal
    if (e.ctrlKey || !window.bootstrap) {
        e.preventDefault();
        await $c33e153c3b84c13d$var$handleGeneAnnotation();
    } else // Bootstrap modal approach
    try {
        const modal = new bootstrap.Modal(document.getElementById("geneAnnotationModal"));
        modal.show();
    } catch (error) {
        console.error("Error showing modal, falling back to direct annotation:", error);
        await $c33e153c3b84c13d$var$handleGeneAnnotation();
    }
});
else console.warn("Element with ID 'geneAnnotationBtn' not found in the DOM");
/**
 * Handle direct gene annotation when modal is unavailable
 */ async function $c33e153c3b84c13d$var$handleGeneAnnotation() {
    const loadingId = `gene-annotation-${Date.now()}`;
    try {
        // Show modern loading indicator
        window.loadingIndicator?.show(loadingId, {
            message: "Loading gene database...",
            type: "bar",
            overlay: true
        });
        // Try loading the gene data
        const loaded = await (0, $ftuQo.loadGeneData)();
        if (loaded && (0, $5qD1E.STATE).cy) {
            // Update loading message
            window.loadingIndicator?.updateMessage(loadingId, "Annotating nodes...");
            // Annotate all nodes in the graph
            const nodeCount = (0, $5qD1E.STATE).cy.nodes().length;
            const annotatedCount = await (0, $ftuQo.annotateAllNodes)((0, $5qD1E.STATE).cy);
            // Update progress
            window.loadingIndicator?.updateProgress(loadingId, 100);
            // Hide loading and show success
            setTimeout(()=>{
                window.loadingIndicator?.hide(loadingId);
                window.showAlert?.(`Annotated ${annotatedCount} of ${nodeCount} nodes with gene information!`, "success", 3000);
            }, 500);
        } else {
            console.error("Could not load gene data or graph not initialized");
            window.loadingIndicator?.hide(loadingId);
            window.showAlert?.("Failed to load gene annotations.", "error");
        }
    } catch (error) {
        console.error("Error in gene annotation:", error);
        window.loadingIndicator?.hide(loadingId);
        window.showAlert?.("Error in gene annotation process: " + error.message, "error");
    }
}
// Add event handler for GTAViz IDs file upload
document.addEventListener("click", (event)=>{
    if (event.target.id === "uploadAuroraIds" || event.target.parentElement && event.target.parentElement.id === "uploadAuroraIds") {
        const fileInput = document.getElementById("auroraIdsFile");
        if (fileInput && window.handleAuroraIdsFileUpload) window.handleAuroraIdsFileUpload();
    }
});
// Add event handler for toolbar collapse toggle on mobile devices
document.addEventListener("DOMContentLoaded", function() {
    const collapseToolbarBtn = document.getElementById("collapseToolbarBtn");
    const toolbar = document.querySelector(".toolbar-responsive");
    if (collapseToolbarBtn && toolbar) {
        // Default to collapsed state on small screens
        if (window.innerWidth < 768) {
            toolbar.classList.add("toolbar-collapsed");
            collapseToolbarBtn.innerHTML = '<i class="bi bi-chevron-down"></i>';
        }
        collapseToolbarBtn.addEventListener("click", function() {
            toolbar.classList.toggle("toolbar-collapsed");
            // Update the icon based on collapsed state
            if (toolbar.classList.contains("toolbar-collapsed")) collapseToolbarBtn.innerHTML = '<i class="bi bi-chevron-down"></i>';
            else collapseToolbarBtn.innerHTML = '<i class="bi bi-chevron-up"></i>';
        });
    }
});
// Also handle window resize events to maintain UI consistency
window.addEventListener("resize", function() {
    const toolbar = document.querySelector(".toolbar-responsive");
    const collapseToolbarBtn = document.getElementById("collapseToolbarBtn");
    if (toolbar && collapseToolbarBtn) {
        if (window.innerWidth >= 768) // On larger screens, always expand toolbar
        toolbar.classList.remove("toolbar-collapsed");
        else if (!toolbar.classList.contains("toolbar-collapsed")) {
            // On smaller screens, collapse by default if not already collapsed
            toolbar.classList.add("toolbar-collapsed");
            collapseToolbarBtn.innerHTML = '<i class="bi bi-chevron-down"></i>';
        }
    }
});


//# sourceMappingURL=app.c6eec5a6.js.map
